import type { AdsFeedImportMode } from "./adsFeedImportSectionTypes";

export function AdsAssistantFeedImportMetaPanel(props: {
  embedded: boolean | undefined;
  metaLoading: boolean;
  metaConfigured: boolean;
  metaUpdatedAt: string | null;
  encryptionConfigured: boolean;
  canEditMetaToken: boolean;
  mode: AdsFeedImportMode;
  saveTokenDraft: string;
  setSaveTokenDraft: (v: string) => void;
  saveVaultBusy: boolean;
  metaBanner: string | null;
  saveOrgToken: () => void;
  clearOrgToken: () => void;
}) {
  const {
    embedded,
    metaLoading,
    metaConfigured,
    metaUpdatedAt,
    encryptionConfigured,
    canEditMetaToken,
    mode,
    saveTokenDraft,
    setSaveTokenDraft,
    saveVaultBusy,
    metaBanner,
    saveOrgToken,
    clearOrgToken,
  } = props;

  if (mode !== "facebook_graph_fetch") return null;

  return (
    <div
      className={
        (embedded ? "mt-0" : "mt-3") +
        " rounded-lg border border-indigo-200/80 bg-white/70 px-3 py-2 dark:border-indigo-900/50 dark:bg-zinc-900/40"
      }
    >
      {metaLoading ? (
        <p className="text-[11px] text-gray-500">Loading Meta import settings…</p>
      ) : (
        <>
          <p className="text-[11px] text-gray-700 dark:text-gray-300">
            <strong>Org token:</strong>{" "}
            {metaConfigured
              ? `saved (${metaUpdatedAt ? new Date(metaUpdatedAt).toLocaleString() : "unknown time"})`
              : "not saved yet"}
            {encryptionConfigured ? "" : " · server encryption key missing"}
          </p>
          {!canEditMetaToken && mode === "facebook_graph_fetch" && !metaConfigured && encryptionConfigured ? (
            <p className="mt-1 text-[11px] text-amber-800 dark:text-amber-200">
              Ask marketing, admin, owner, or dev to save the Meta page token in Ads → Ingestion before you can run Facebook
              fetch.
            </p>
          ) : null}
          {canEditMetaToken ? (
            <details className="mt-2">
              <summary className="cursor-pointer text-xs font-semibold text-indigo-900 dark:text-indigo-200">
                Save Meta page token for everyone (marketing / admin / owner / dev)
              </summary>
              <p className="mt-1 text-[10px] text-gray-600 dark:text-gray-400 max-w-prose">
                Paste the Page access token from Graph API Explorer (
                <code className="rounded bg-gray-100 px-0.5 dark:bg-zinc-800">me/accounts</code>
                ). It is encrypted and stored server-side. Sales and trainers can run fetch without seeing it.
              </p>
              <input
                className="mt-1 w-full rounded-lg border border-gray-200 bg-white px-2 py-1.5 text-xs font-mono dark:border-gray-600 dark:bg-zinc-950 dark:text-gray-100"
                type="password"
                autoComplete="off"
                value={saveTokenDraft}
                onChange={(e) => setSaveTokenDraft(e.target.value)}
                placeholder="Page access token to save for this org"
                disabled={saveVaultBusy || !encryptionConfigured}
              />
              <div className="mt-2 flex flex-wrap gap-2">
                <button
                  type="button"
                  disabled={saveVaultBusy || !encryptionConfigured}
                  onClick={() => void saveOrgToken()}
                  className="rounded-lg bg-indigo-600 px-2.5 py-1 text-xs font-medium text-white hover:bg-indigo-700 disabled:opacity-50"
                >
                  {saveVaultBusy ? "Saving…" : "Save for org"}
                </button>
                <button
                  type="button"
                  disabled={saveVaultBusy || !metaConfigured}
                  onClick={() => void clearOrgToken()}
                  className="rounded-lg border border-gray-300 bg-white px-2.5 py-1 text-xs text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-zinc-600 dark:bg-zinc-900 dark:text-gray-200"
                >
                  Clear saved
                </button>
              </div>
            </details>
          ) : null}
        </>
      )}
      {metaBanner ? <p className="mt-2 text-[11px] text-emerald-700 dark:text-emerald-300">{metaBanner}</p> : null}
    </div>
  );
}
